export default __webpack_public_path__ + "static/getappx2-f2142d2948f7c385e8142e4a18ccb0d7.svg";